<template>
  <div class="actions">
    <a
      href="javascript:void(0)"
      class="btn btn-primary btn-icon"
      data-toggle="modal"
      data-target="#update-race"
      @click.prevent="setSelected"
    > 
      <i class="icofont icofont-pencil" />
    </a>
    <a
      href="javascript:void(0)"
      class="btn btn-danger btn-sm"
      @click.prevent="deletingType"
    > 
      <i class="icofont icofont-close" />
    </a>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { DELETE_TYPE_ROBE } from '../../../graphql/identification';
import {MODE_EDIT} from '../../../constants/app'
export default {
    props: {object: {type: Object, required: true}},
    data(){
        return  {

        }
    },
    methods: {
        ...mapMutations({
            setSelectedRace: 'SET_SELECTED_OBJECT',
            setMode: 'SET_MODE'
        }),
        setSelected(){
            this.setSelectedRace(this.object)
            this.setMode(MODE_EDIT)
        },
        deletingType(){
            this.$apollo.mutate({
                mutation: DELETE_TYPE_ROBE,
                variables: {
                    "uid": this.object.uid
                },
                update: (data) => {
                    if(data) console.log(`Type robe ${this.object.libelle} at ${this.object.uid} deleted successfully`)
                    else console.log(`Error in deletting resultanalyse ${this.object.libelle}`)
                }
              }).then(() => {
                
              })

        }
    },
    computed: {
        ...mapGetters({

        })
    }
}
</script>

<style lang="scss" scoped>
.actions{
    a{
        margin: 0px 5px;
    }
}
</style>